import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { matchEligibility, popularCategories } from "@/utils/banners";

export const usePopularCategoriesBanners = () => {
  const { sessionInfo } = useSessionContext();
  const { t } = useI18nContext();

  return useMemo(() => {
    const items = popularCategories(t);
    return items.filter((item) => {
      return matchEligibility(
        sessionInfo?.userDetails,
        item.eligibilityPayloadMapping
      );
    });
  }, [sessionInfo?.userDetails]);
};
